import { createContext, type ReactNode, useContext, useEffect, useState } from 'react'
import { twMerge } from 'tailwind-merge'
import { FullPageSpin } from '../FullPageSpin'

type FancyAppLoaderContextProps = {
  show: () => void
  hide: () => void
  forceShow: () => void
  forceHide: () => void
}

export const FancyAppLoaderContext = createContext<FancyAppLoaderContextProps>({
  show: () => null,
  hide: () => null,
  forceShow: () => null,
  forceHide: () => null,
})

type FancyAppLoaderProviderProps = {
  children: ReactNode
}

export const FancyAppLoaderProvider = ({ children }: FancyAppLoaderProviderProps) => {
  const [isLoaderVisible, setIsLoaderVisible] = useState(false)
  const [isLoaderForceVisible, setIsLoaderForceVisible] = useState(false)
  const [isFirstLoad, setIsFirstLoad] = useState(true)

  useEffect(() => {
    if (!isFirstLoad) {
      return
    }

    const timeoutId = setTimeout(() => {
      setIsFirstLoad(false)
    }, 300)

    if (isLoaderVisible || isLoaderForceVisible) {
      clearTimeout(timeoutId)
    }

    return () => clearTimeout(timeoutId)
  }, [isLoaderVisible, isLoaderForceVisible, isFirstLoad])

  return (
    <FancyAppLoaderContext.Provider
      value={{
        show: () => setIsLoaderVisible(true),
        hide: () => setIsLoaderVisible(false),
        forceShow: () => setIsLoaderForceVisible(true),
        forceHide: () => setIsLoaderForceVisible(false),
      }}
    >
      {children}
      <div
        className={twMerge(
          'fixed inset-0 bg-white transition-opacity',
          isLoaderForceVisible || (isFirstLoad && isLoaderVisible)
            ? 'pointer-events-auto opacity-100'
            : 'pointer-events-none opacity-0'
        )}
      >
        <FullPageSpin />
      </div>
    </FancyAppLoaderContext.Provider>
  )
}

export const useFancyAppLoader = () => useContext(FancyAppLoaderContext)
